import styled, { css , keyframes} from 'styled-components';
import { em, rem } from 'polished';
import { media } from 'core/layout';
import { colors } from 'core/theme';

const slideIn = keyframes`
  from {
    transform: translateY(-4px);
  }

  to {
     transform: translateY(0px);
  }
`;

     // border-bottom: 1px solid ${colors.hairline};


export const StyledItem = styled.li`

    a + h2 {
        border-top: 1px solid ${colors.hairline};
    }


    > div {
            display: none;
           > div {
           }
    }
    &:first-child {
         > a {
            margin-top:0;
           h2 {
             margin-top:0;
           }
         }
    }

    &.opened {
         > div {
            animation: ${slideIn} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            display: block;
            > div {
               > div:not(:first-child){
               }
             }
         }


        & + li {
            h2 {
                border-top: 1px solid ${colors.hairline};
            }
        }
    }

    @media print {
      page-break-inside: auto;

      &:not(.opened):not(.title) {
        display: none;
      }

      &:not(.opened).title {
        & > *:not(a) {
          display: none;
        }
      }

      h2 {
        font-size: 1.2rem !important;
        margin-bottom: 0.5rem !important;
      }

      & > h2 > a {
        font-size: 1.2rem !important;
      }

      h3 {
        font-size: 1.1rem !important;
        margin-bottom: 0.5rem !important;
      }

      &:not(:first-child).title {
        page-break-before: always;
      }
    }
`;

export const StyledItemAnchor = styled.a`
    margin-top: ${rem(42)};
    display: block;

    font-size: ${rem(24)};



   > h2 {
        border-top: none !important;
    margin-top: ${rem(42)};
    font-size: ${rem(24)};
   }

    ${media.tablet`
            font-size: ${rem(18)};
           > h2 {
            font-size: ${rem(18)};
           }
        `};

    @media print {
      margin-top: 2rem;

      &:before {
        content: "#";
        font-size: 1.5rem;
        font-weight: 500;
      }

      h2 {
        display: inline-block;
        margin-left: 0.5em;
        margin-top: 0;
      }
    }
`;
export const StyledFlex = styled.div`
    display: flex;
    justify-content:space-between;
    padding: ${rem(24)} 0;

        &:not(:last-child){
            border-bottom: 1px solid ${colors.hairline};
        }

       > div {
        color: ${colors.subtleText};

        &:first-child {
          padding-right: 2em !important;
        }
       }

        ${media.tablet`
           padding: ${rem(8)} 0;


           > div {
            font-size: ${em(12)};

            &:not(:last-child){
                padding-right: ${em(12)};
                overflow:hidden;
                text-overflow: ellipsis;
            }
           }
        `};

    @media print {
      page-break-inside: avoid;
    }
`;

export const StyledFlexHeader = StyledFlex.extend`
     > div {
        margin-top: ${rem(18)};
        font-size: ${rem(14)};
        color: ${colors.lightText};
         ${media.tablet`
           font-size: ${rem(12)};
        `};
       }
`;


export const StyledMainAnchor = styled.a`
     text-decoration: none;
     color: inherit;
     display: block;
     position:relative;
     font-weight:400;
     padding-right:${rem(24)};

     &:after {
        content:'';
        position:absolute;
        right:0;
        top:50%;
        background-image: url(${require('!!url-loader!core/icons/assets/arrow-drop-down.svg')});
        background-repeat:no-repeat;
        background-size:24px 24px;
        width: 24px;
        height: 24px;
        transform-origin: 50% 25%;
        transform:translateY(-50%);
     }

    &:hover {
         &:after {
            background-image: url(${require('!!url-loader!core/icons/assets/arrow-drop-down-green.svg')});
        }
    }

    &.opened {
        &:after {
            background-image: url(${require('!!url-loader!core/icons/assets/arrow-drop-down-green.svg')});
            transform:rotate(180deg);
        }
    }

        ${media.tablet`
            font-size: ${rem(16)};
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `};

`;

export const StyledHeading = styled.h2`
    font-size: ${em(18)};
    font-weight: 400;
    color: ${colors.text};
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    margin:0;

    border-bottom: 1px solid ${colors.hairline};
`;

export const StyledKontakts = styled.li`
   display: flex;
`;

export const StyledGroup = styled.div`

    margin-bottom: ${rem(18)};



    h3 {
        font-size: 1em
        font-weight: 500;
        color: ${colors.text};
        margin-top: ${rem(24)};
        margin-bottom: 0em;
        line-height:1;
    }
    font-size: 1rem;
    a {
         color: ${colors.primary};
    }
    > div {



        > div {
           // &:nth-child(even){
           //   background-color:#f5dfd3;
           // }
        }
    }

    @media print {
      font-size: 1.5rem;

      a {
        display: inline-block;
        margin: 0.25em 0;

        &:after {
          display: none;
        }
      }
    }
`;

export const TagsList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    font-size: ${em(14)};
    color: ${colors.lightText};

    & > li + li {
        margin-left: 24px;

        ${media.tablet`
            margin-left: 16px;
        `};
    }

    & > li {
        flex: 0 0 ${(2/7) * 100}%;
    }
`;



// WEBPACK FOOTER //
// ./src/pages/KontaktiRezultati/components/KontaktuRezultatsItem/styled.js